import StackdriverErrorReporter from "stackdriver-errors-js";

const errorHandler = new StackdriverErrorReporter();
errorHandler.start({
  key: process.env.REACT_APP_PROJECT_API_KEY ?? "",
  projectId: process.env.REACT_APP_PROJECT_ID ?? "",
  service: process.env.REACT_APP_PROJECT_ID ?? "",
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function setError(error: any) {
  errorHandler.report(error ?? "some errors");
}

export function setUser(auth: { uid: string }) {
  if (auth?.uid && errorHandler?.setUser) {
    errorHandler.setUser(auth.uid);
  }
}

export default errorHandler;

export const ApiErrorHandler = (
  message: string,
  url: string,
  headers: string,
  method: string
) => {
  // custom error obj
  const headersObj = JSON.parse(headers);
  const jsonErrorMsg = {
    name: `${"web Front-end"}`,
    message: `${message}`,
    "@type": `${message}`,
    context: {
      httpRequest: {
        method: `${method}`,
        url: `${url}`,
      },
    },
    correlation_id: headersObj["correlation-id"],
  };

  // set Custom Error
  setError(JSON.stringify(jsonErrorMsg));
  return jsonErrorMsg;
};
